/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CustomerOrderDetailsExport,
  CustomerOrderDetailsWithOrderItems,
  PagedAndSyncedResultCustomerOrderSummary,
  SortDirection,
} from '../models/index';
import {
    CustomerOrderDetailsExportFromJSON,
    CustomerOrderDetailsExportToJSON,
    CustomerOrderDetailsWithOrderItemsFromJSON,
    CustomerOrderDetailsWithOrderItemsToJSON,
    PagedAndSyncedResultCustomerOrderSummaryFromJSON,
    PagedAndSyncedResultCustomerOrderSummaryToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/index';

export interface GetCustomerOrderSummariesOfCurrentRetailerRequest {
    offset?: number;
    limit?: number;
    createdBetweenFrom?: Date;
    createdBetweenUntil?: Date;
    fullTextQuery?: string;
    sortByCreatedAt?: SortDirection;
    sortByTotal?: SortDirection;
    sortByCustomerReference?: SortDirection;
    sortByTransactionNumber?: SortDirection;
}

export interface GetCustomerOrderSummariesOfCurrentRetailerCsvExportRequest {
    createdBetweenFrom?: Date;
    createdBetweenUntil?: Date;
    fullTextQuery?: string;
}

export interface GetCustomerOrderWithOrderItemsOfCurrentRetailerByCustomerOrderIdRequest {
    customerOrderId: number;
}

/**
 * 
 */
export class CustomerOrderResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getCustomerOrderSummariesOfCurrentRetailer without sending the request
     */
    async getCustomerOrderSummariesOfCurrentRetailerRequestOpts(requestParameters: GetCustomerOrderSummariesOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['createdBetweenFrom'] != null) {
            queryParameters['createdBetweenFrom'] = (requestParameters['createdBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['createdBetweenUntil'] != null) {
            queryParameters['createdBetweenUntil'] = (requestParameters['createdBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['fullTextQuery'] != null) {
            queryParameters['fullTextQuery'] = requestParameters['fullTextQuery'];
        }

        if (requestParameters['sortByCreatedAt'] != null) {
            queryParameters['sortByCreatedAt'] = requestParameters['sortByCreatedAt'];
        }

        if (requestParameters['sortByTotal'] != null) {
            queryParameters['sortByTotal'] = requestParameters['sortByTotal'];
        }

        if (requestParameters['sortByCustomerReference'] != null) {
            queryParameters['sortByCustomerReference'] = requestParameters['sortByCustomerReference'];
        }

        if (requestParameters['sortByTransactionNumber'] != null) {
            queryParameters['sortByTransactionNumber'] = requestParameters['sortByTransactionNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/customer-order`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getCustomerOrderSummariesOfCurrentRetailerRaw(requestParameters: GetCustomerOrderSummariesOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedAndSyncedResultCustomerOrderSummary>> {
        const requestOptions = await this.getCustomerOrderSummariesOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedAndSyncedResultCustomerOrderSummaryFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerOrderSummariesOfCurrentRetailer(requestParameters: GetCustomerOrderSummariesOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedAndSyncedResultCustomerOrderSummary> {
        const response = await this.getCustomerOrderSummariesOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCustomerOrderSummariesOfCurrentRetailerCsvExport without sending the request
     */
    async getCustomerOrderSummariesOfCurrentRetailerCsvExportRequestOpts(requestParameters: GetCustomerOrderSummariesOfCurrentRetailerCsvExportRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['createdBetweenFrom'] != null) {
            queryParameters['createdBetweenFrom'] = (requestParameters['createdBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['createdBetweenUntil'] != null) {
            queryParameters['createdBetweenUntil'] = (requestParameters['createdBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['fullTextQuery'] != null) {
            queryParameters['fullTextQuery'] = requestParameters['fullTextQuery'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/customer-order/export`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getCustomerOrderSummariesOfCurrentRetailerCsvExportRaw(requestParameters: GetCustomerOrderSummariesOfCurrentRetailerCsvExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerOrderDetailsExport>>> {
        const requestOptions = await this.getCustomerOrderSummariesOfCurrentRetailerCsvExportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerOrderDetailsExportFromJSON));
    }

    /**
     */
    async getCustomerOrderSummariesOfCurrentRetailerCsvExport(requestParameters: GetCustomerOrderSummariesOfCurrentRetailerCsvExportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerOrderDetailsExport>> {
        const response = await this.getCustomerOrderSummariesOfCurrentRetailerCsvExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCustomerOrderWithOrderItemsOfCurrentRetailerByCustomerOrderId without sending the request
     */
    async getCustomerOrderWithOrderItemsOfCurrentRetailerByCustomerOrderIdRequestOpts(requestParameters: GetCustomerOrderWithOrderItemsOfCurrentRetailerByCustomerOrderIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling getCustomerOrderWithOrderItemsOfCurrentRetailerByCustomerOrderId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/customer-order/{customerOrderId}`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getCustomerOrderWithOrderItemsOfCurrentRetailerByCustomerOrderIdRaw(requestParameters: GetCustomerOrderWithOrderItemsOfCurrentRetailerByCustomerOrderIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerOrderDetailsWithOrderItems>> {
        const requestOptions = await this.getCustomerOrderWithOrderItemsOfCurrentRetailerByCustomerOrderIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerOrderDetailsWithOrderItemsFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerOrderWithOrderItemsOfCurrentRetailerByCustomerOrderId(requestParameters: GetCustomerOrderWithOrderItemsOfCurrentRetailerByCustomerOrderIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerOrderDetailsWithOrderItems> {
        const response = await this.getCustomerOrderWithOrderItemsOfCurrentRetailerByCustomerOrderIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
